import React, { useEffect, useRef, useState } from "react";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress, Switch } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import SendIcon from "@mui/icons-material/Send";
import MinimizeIcon from "@mui/icons-material/Minimize";
import { chatServices } from "../../services/chatServices";
import { isEmptyDash, SOCKET_SERVER_URL } from "../../constant";
import _ from "lodash";
import { UserObj } from "../../services/localStarage";
import ChatActiveUser from "./chatActiveUser";
import ChatOtherUser from "./chatOtherUser";
import { onboardingServices } from "../../services/onboardingServices";
import axios from "axios";
import socketIOClient from 'socket.io-client';

function SupportChat(props) {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [isThank, setIsThank] = useState(false);
  const [chatText, setChatText] = useState("");
  const [chatOpen, setChatOpen] = useState(false);
  const [chatData, setChatData] = useState([]);
  const [currentChatPageNo, setCurrentChatPageNo] = useState(1);
  const [updateForScroll, setUpdateForScroll] = useState(0);
  const [isPrivate, setIsPrivate] = useState(true);
  const paragraphRef = useRef(null);
  const fileRef = useRef(null);

  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  let navigate = useNavigate();


  const handleClose = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  useEffect(() => {

    const token = `${UserObj?.accessToken}`;
    const socket = socketIOClient(SOCKET_SERVER_URL, {
      auth: {
        token: token
      }
    });
    socket.on('receive-comment', (data) => {
      // setResponse(data);     
      if (UserObj?.role.name == "VENDOR" && data.isPublic == false) {

      } else {
        setChatData((prevData) => [...prevData, data]);
      }
    });
    socket.emit('add-vendor', { vendorId: props?.vendorDetails?.vendor?._id });

    // if (location.pathname.includes("/admin/vendor-list-details")) {
    //   socket.emit('add-vendor', { vendorId: props?.vendorDetails?.vendor?._id });
    // }
    if (
      location.pathname.includes("/admin/Engineering-Bidding-Technical-Evaluation")
      || location.pathname.includes("/admin/Buyer-Bidding-Rfq-Creaction-Form")
      || location.pathname.includes("/admin/Buyer-Bidding-Commercial-Comparision-Round-1")
      || location.pathname.includes("/admin/Buyer-Bidding-Commercial-Comparison")
    ) {
      socket.emit('add-vendor-rfq', { "vendorId": props?.vendorDetails?.vendor?._id, "rfqId": props?.comparisonData?.rfqId });
    }

    if (
      location.pathname.includes("/admin/po-detail-services")
      || location.pathname.includes("/admin/qc-detail")
      || location.pathname.includes("/admin/vendor-LR-Deatil")
      || location.pathname.includes("/admin/vendor-Gate-Entry-Detail")
      || location.pathname.includes("/admin/grn-deatil")
    ) {
      socket.emit('add-vendor-p2p', { "vendorId": props?.vendorDetails?.vendor?._id, "refType": props?.P2PData?.refType, "referenceId": props?.P2PData?.referenceId  });
    }

    return () => {
      if (location.pathname.includes("/admin/vendor-list-details")) {
        socket.emit('remove-vendor', { vendorId: props?.vendorDetails?.vendor?._id });
      }
      if (location.pathname.includes("/admin/Engineering-Bidding-Technical-Evaluation")
        || location.pathname.includes("/admin/Buyer-Bidding-Rfq-Creaction-Form")
        || location.pathname.includes("/admin/Buyer-Bidding-Commercial-Comparision-Round-1")
        || location.pathname.includes("/admin/Buyer-Bidding-Commercial-Comparison")
      ) {
        socket.emit('remove-vendor', { "vendorId": props?.vendorDetails?.vendor?._id, "rfqId": props?.comparisonData?.rfqId });
      }
      
      if (
        location.pathname.includes("/admin/po-detail-services")
        || location.pathname.includes("/admin/qc-detail")
        || location.pathname.includes("/admin/vendor-LR-Deatil")
        || location.pathname.includes("/admin/vendor-Gate-Entry-Detail")
        || location.pathname.includes("/admin/grn-deatil")
      ) {
        socket.emit('remove-vendor', { "vendorId": props?.vendorDetails?.vendor?._id, "refType": props?.P2PData?.refType, "referenceId": props?.P2PData?.referenceId  });
      }
    };
  }, [props?.vendorDetails?.vendor?._id]);

  useEffect(() => {
    if (!isEmptyDash(props?.vendorDetails?.vendor?._id)) {
      getAllComment(props?.vendorDetails?.vendor?._id, currentChatPageNo);
    }
  }, [props?.vendorDetails?.vendor?._id]);

  useEffect(() => {
    paragraphRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [updateForScroll]);

  const handleClick = () => {
    fileRef.current.click();
  };

  const uploadAttachement = (e) => {
    e.preventDefault();
    let formData = new FormData();
    formData.append("file", e.target.files[0]);
    let files = e.target.files[0];
    setIsLoading(true);
    onboardingServices
      .uploadFile(formData)
      .then(function (response) {
        if (response?.data?.success === true) {
          let isPublicValue = false;
          if (!isPrivate) {
            isPublicValue = true;
          }
          // let obj = {
          //   vendorId: props?.vendorDetails?.vendor?._id,
          //   isPublic: isPublicValue,
          //   referenceURL: response?.data?.data?.data?.key,
          // };
          let obj = {
            files: [
              {
                key: response?.data?.data?.data?.key,
                name: files?.name,
                fileType: files?.type,
                mimeType: files?.type,
                size: files?.size,
              },
            ],
            vendorId: props?.vendorDetails?.vendor?._id,
            isPublic: isPublicValue,
          };
          addComment(obj);
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const viewUrlData = (data) => {
    setIsLoading(true);

    onboardingServices
      .viewUrlData(data?.key)
      .then(function (response) {
        if (response?.data?.success == true) {
          // fetch(`${response?.data?.data?.url}`)
          // .then(response => response.text())
          // .then(result => console.log(result))
          // .catch(error => console.log('error', error));
          console.log("viewUrlData: ", data, response);
          
          axios({
            url: `${response?.data?.data?.url}`,
            method: "GET",
            responseType: "blob",
            headers: {
              "Access-Control-Allow-Origin": "*",
              cors: "no-cors",
            },
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data],  { type: data?.mimeType }));
            const link = document.createElement("a");
            link.href = url;
            
            link.setAttribute("download", `${data?.name}`);
            document.body.appendChild(link);
            link.click();
          });
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const getAllComment = (vendorId, pageNo) => {
    setIsLoading(true);
    let comparisonParam = "";
    if (props?.isComparison == true) {
      comparisonParam = `&moduleName=BIDDING&rfqId=${props?.comparisonData?.rfqId}`
    }
    if (props?.isP2P == true) {
      comparisonParam = `&moduleName=P2P&refType=${props?.P2PData?.refType}&referenceId=${props?.P2PData?.referenceId}`
    }
    chatServices
      .getAllComment(`?vendorId=${vendorId}&pageNo=${pageNo}${comparisonParam}`)
      .then(function (response) {
        if (response?.data?.success === true) {
          const responseData = response.data.data?.comments;
          if (responseData && Array.isArray(responseData)) {
            const chatDataInit = _.cloneDeep(chatData);
            const newChat = responseData.reverse();
            const newArr = [...newChat, ...chatDataInit];
            setChatData(newArr);
            setUpdateForScroll(updateForScroll + 1);
          } else {
            // openAlert(true, "error", "No more data found");
          }
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const addComment = (bodyData) => {
    setIsLoading(true);
    if (props?.isComparison == true) {
      bodyData["moduleName"] = "BIDDING";
      bodyData["rfqId"] = props?.comparisonData?.rfqId;
    }
    
    if (props?.isP2P == true) {
      bodyData["moduleName"] = "P2P";
      bodyData["refType"] = props?.P2PData?.refType;
      bodyData["referenceId"] = props?.P2PData?.referenceId;
    }

    // socket.emit('receive-comment', bodyData);
    chatServices
      .addComment(bodyData)
      .then(function (response) {
        if (response?.data?.success == true) {
          let chatDataInit = _.cloneDeep(chatData);
          let responseData = response?.data?.data;
          responseData.isVendor =
            UserObj?.role?.name === "VENDOR" ? true : false;
          chatDataInit.push(responseData);
          setChatData(chatDataInit);
          setIsLoading(true);
          setChatText("");
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
        setUpdateForScroll(updateForScroll + 1);
      });
  };

  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };

  const isEmptyDash1 = (params) => {
    if (
      params == undefined ||
      params == null ||
      params == ""
      // params == "null"
    ) {
      return true;
    } else {
      return false;
    }
  };

  const submitForm = () => {
    if (isEmptyDash1(chatText)) {
      openAlert(true, "error", `Please enter some text.`);
      return;
    }
    let isPublicValue = false;
    if (!isPrivate) {
      isPublicValue = true;
    }
    let obj = {
      comment: chatText,
      vendorId: props?.vendorDetails?.vendor?._id,
      isPublic: isPublicValue,
    };
    addComment(obj);
  };

  const onTextChange = (e) => {
    let { value } = e.target;
    setChatText(value);
  };

  const onKeyPressHandler = (e) => {
    e.persist();
    if (e.key === "Enter") {
      submitForm();
    }
  };
  const openChat = () => {
    setChatOpen(!chatOpen);
    if (chatOpen && props.onMinimize) { /** for chatbox open from vendor side */
      props.onMinimize();
    }
  };

  useEffect(() => {
    if (props?.comparisonData?.isVendorChatBoxOpen) {
      setChatOpen(props?.comparisonData?.isVendorChatBoxOpen);
    }
  }, [props?.comparisonData?.isVendorChatBoxOpen]);

  const fetchMoreData = () => {
    let pagenumber = currentChatPageNo + 1;
    setCurrentChatPageNo(pagenumber);
    getAllComment(props?.vendorDetails?.vendor?._id, pagenumber);
  };

  const handleScroll = (e) => {
    let ele = e.target;
    if (ele && ele.scrollTop === 0) {
      fetchMoreData(); // Call fetchMoreData to load older messages
    }
  };
  // const chaboxStyle = () => {
  //   return {
  //     background: '#F2F2F2',
  //     paddingRight: '42px',
  //     paddingTop: '10px',
  //     paddingBottom: '10px',
  //     color: '#9F9FA6'

  //   };
  // };
  const activeUser = (id, chatData, ele, i) => {
    if (chatData.length - 1 !== i) {
      if (ele?.commentBy === id) {
        return chatData[i + 1];
      }
    }
    return null;
  };
  const otherUser = (id, chatData, ele, i) => {
    if (chatData.length - 1 !== i) {
      if (ele?.commentBy !== id) {
        return chatData[i + 1];
      }
    }
    return null;
  };

  const formatDate = (date) => {
    const dateObject = new Date(date);
    const formattedDate = dateObject.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
    return formattedDate;
  };

  const shouldDisplayNewDate = (index) => {
    if (index === 0) {
      return true;
    } else {
      const currentDate = formatDate(chatData[index].createdAt);
      const previousDate = formatDate(chatData[index - 1].createdAt);
      if (currentDate !== previousDate) {
        return true;
      } else {
        return false;
      }
    }
  };

  return (
    <div class="login-forms">
      <div class="text-centers">
        <div className="chat_box_main" style={(props?.isComparison != true) ? { display: "block" } : (props?.comparisonData?.isActive == true) ? { display: "block" } : { display: "none" }}>
          <div className="chat_bx" onClick={openChat}>
            <a href="#" id="liveToastBtn">
              <svg
                width="77"
                height="90"
                viewBox="0 0 77 111"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.3248 73.0909V84H12.3326L7.58647 77.1339H7.50657V84H5.20011V73.0909H7.22425L11.9331 79.9517H12.0289V73.0909H14.3248ZM19.9165 84.1598C19.0748 84.1598 18.3504 83.9893 17.7432 83.6484C17.1395 83.304 16.6743 82.8175 16.3476 82.1889C16.0209 81.5568 15.8575 80.8093 15.8575 79.9464C15.8575 79.1048 16.0209 78.3661 16.3476 77.7305C16.6743 77.0948 17.1341 76.5994 17.7272 76.2443C18.3238 75.8892 19.0233 75.7116 19.8259 75.7116C20.3657 75.7116 20.8682 75.7987 21.3334 75.9727C21.8021 76.1431 22.2105 76.4006 22.5585 76.745C22.9101 77.0895 23.1835 77.5227 23.3788 78.0447C23.5741 78.5632 23.6718 79.1705 23.6718 79.8665V80.4897H16.7631V79.0835H21.5358C21.5358 78.7567 21.4648 78.4673 21.3227 78.2152C21.1807 77.9631 20.9836 77.766 20.7314 77.6239C20.4829 77.4783 20.1934 77.4055 19.8632 77.4055C19.5187 77.4055 19.2133 77.4854 18.947 77.6452C18.6842 77.8015 18.4782 78.0128 18.3291 78.2791C18.18 78.5419 18.1036 78.8349 18.1001 79.158V80.495C18.1001 80.8999 18.1746 81.2496 18.3238 81.5444C18.4765 81.8391 18.6913 82.0664 18.9683 82.2262C19.2453 82.386 19.5738 82.4659 19.9537 82.4659C20.2059 82.4659 20.4367 82.4304 20.6462 82.3594C20.8557 82.2884 21.0351 82.1818 21.1842 82.0398C21.3334 81.8977 21.447 81.7237 21.5251 81.5178L23.6238 81.6562C23.5173 82.1605 23.2989 82.6009 22.9687 82.9773C22.642 83.3501 22.2194 83.6413 21.7009 83.8509C21.186 84.0568 20.5912 84.1598 19.9165 84.1598ZM28.8813 84.1598C28.0397 84.1598 27.3153 83.9893 26.708 83.6484C26.1043 83.304 25.6391 82.8175 25.3124 82.1889C24.9857 81.5568 24.8224 80.8093 24.8224 79.9464C24.8224 79.1048 24.9857 78.3661 25.3124 77.7305C25.6391 77.0948 26.099 76.5994 26.692 76.2443C27.2886 75.8892 27.9882 75.7116 28.7907 75.7116C29.3305 75.7116 29.833 75.7987 30.2982 75.9727C30.767 76.1431 31.1753 76.4006 31.5233 76.745C31.8749 77.0895 32.1483 77.5227 32.3437 78.0447C32.539 78.5632 32.6366 79.1705 32.6366 79.8665V80.4897H25.7279V79.0835H30.5006C30.5006 78.7567 30.4296 78.4673 30.2876 78.2152C30.1455 77.9631 29.9484 77.766 29.6963 77.6239C29.4477 77.4783 29.1583 77.4055 28.828 77.4055C28.4836 77.4055 28.1782 77.4854 27.9118 77.6452C27.6491 77.8015 27.4431 78.0128 27.2939 78.2791C27.1448 78.5419 27.0684 78.8349 27.0649 79.158V80.495C27.0649 80.8999 27.1395 81.2496 27.2886 81.5444C27.4413 81.8391 27.6562 82.0664 27.9331 82.2262C28.2101 82.386 28.5386 82.4659 28.9186 82.4659C29.1707 82.4659 29.4015 82.4304 29.6111 82.3594C29.8206 82.2884 29.9999 82.1818 30.1491 82.0398C30.2982 81.8977 30.4118 81.7237 30.49 81.5178L32.5887 81.6562C32.4822 82.1605 32.2638 82.6009 31.9335 82.9773C31.6068 83.3501 31.1842 83.6413 30.6657 83.8509C30.1508 84.0568 29.556 84.1598 28.8813 84.1598ZM37.1324 84.1332C36.5109 84.1332 35.9481 83.9734 35.4438 83.6538C34.9431 83.3306 34.5454 82.8565 34.2506 82.2315C33.9594 81.603 33.8138 80.8324 33.8138 79.9197C33.8138 78.9822 33.9648 78.2028 34.2666 77.5813C34.5684 76.9563 34.9697 76.4893 35.4704 76.1804C35.9747 75.8679 36.5269 75.7116 37.127 75.7116C37.5851 75.7116 37.9669 75.7898 38.2723 75.946C38.5812 76.0987 38.8298 76.2905 39.018 76.5213C39.2098 76.7486 39.3554 76.9723 39.4548 77.1925H39.5241V73.0909H41.7879V84H39.5507V82.6896H39.4548C39.3483 82.9169 39.1974 83.1424 39.002 83.3661C38.8103 83.5863 38.5599 83.7692 38.251 83.9148C37.9456 84.0604 37.5727 84.1332 37.1324 84.1332ZM37.8515 82.3274C38.2172 82.3274 38.5262 82.228 38.7783 82.0291C39.034 81.8267 39.2293 81.5444 39.3643 81.1822C39.5028 80.82 39.572 80.3956 39.572 79.9091C39.572 79.4226 39.5045 79 39.3696 78.6413C39.2346 78.2827 39.0393 78.0057 38.7836 77.8104C38.528 77.6151 38.2172 77.5174 37.8515 77.5174C37.4786 77.5174 37.1643 77.6186 36.9086 77.821C36.653 78.0234 36.4594 78.304 36.328 78.6626C36.1966 79.0213 36.1309 79.4368 36.1309 79.9091C36.1309 80.3849 36.1966 80.8058 36.328 81.1715C36.463 81.5337 36.6565 81.8178 36.9086 82.0238C37.1643 82.2262 37.4786 82.3274 37.8515 82.3274ZM49.4584 84.1545C48.9363 84.1545 48.4711 84.0639 48.0628 83.8828C47.6544 83.6982 47.3312 83.4265 47.0933 83.0678C46.8589 82.7056 46.7417 82.2546 46.7417 81.7148C46.7417 81.2603 46.8252 80.8786 46.9921 80.5696C47.159 80.2607 47.3863 80.0121 47.6739 79.8239C47.9616 79.6357 48.2883 79.4936 48.654 79.3977C49.0233 79.3018 49.4104 79.2344 49.8153 79.1953C50.2911 79.1456 50.6746 79.0994 50.9658 79.0568C51.257 79.0107 51.4683 78.9432 51.5997 78.8544C51.7311 78.7656 51.7968 78.6342 51.7968 78.4602V78.4283C51.7968 78.0909 51.6903 77.8299 51.4772 77.6452C51.2677 77.4606 50.9694 77.3683 50.5823 77.3683C50.1739 77.3683 49.849 77.4588 49.6075 77.6399C49.366 77.8175 49.2062 78.0412 49.1281 78.3111L47.0294 78.1406C47.1359 77.6435 47.3454 77.2138 47.6579 76.8516C47.9704 76.4858 48.3735 76.2053 48.8671 76.0099C49.3643 75.8111 49.9395 75.7116 50.593 75.7116C51.0475 75.7116 51.4825 75.7649 51.898 75.8714C52.317 75.978 52.6881 76.1431 53.0113 76.3668C53.338 76.5906 53.5954 76.8782 53.7836 77.2298C53.9719 77.5778 54.066 77.995 54.066 78.4815V84H51.914V82.8654H51.8501C51.7187 83.1211 51.5429 83.3466 51.3227 83.5419C51.1025 83.7337 50.838 83.8846 50.529 83.9947C50.2201 84.1012 49.8632 84.1545 49.4584 84.1545ZM50.1082 82.5884C50.442 82.5884 50.7368 82.5227 50.9925 82.3913C51.2481 82.2564 51.4488 82.0753 51.5944 81.848C51.74 81.6207 51.8128 81.3633 51.8128 81.0756V80.2074C51.7417 80.2536 51.6441 80.2962 51.5198 80.3352C51.3991 80.3707 51.2623 80.4045 51.1096 80.4364C50.9569 80.4648 50.8042 80.4915 50.6515 80.5163C50.4988 80.5376 50.3604 80.5572 50.2361 80.5749C49.9697 80.614 49.7371 80.6761 49.5383 80.7614C49.3394 80.8466 49.1849 80.962 49.0748 81.1076C48.9648 81.2496 48.9097 81.4272 48.9097 81.6403C48.9097 81.9492 49.0216 82.1854 49.2453 82.3487C49.4726 82.5085 49.7602 82.5884 50.1082 82.5884ZM58.0956 79.2699V84H55.8264V75.8182H57.9891V77.2617H58.085C58.2661 76.7859 58.5697 76.4094 58.9958 76.1325C59.422 75.8519 59.9387 75.7116 60.5459 75.7116C61.1141 75.7116 61.6095 75.8359 62.032 76.0845C62.4546 76.3331 62.7831 76.6882 63.0175 77.1499C63.2519 77.608 63.3691 78.1548 63.3691 78.7905V84H61.0999V79.1953C61.1034 78.6946 60.9756 78.304 60.7164 78.0234C60.4571 77.7393 60.1002 77.5973 59.6457 77.5973C59.3403 77.5973 59.0704 77.663 58.836 77.7944C58.6052 77.9258 58.4241 78.1175 58.2927 78.3697C58.1649 78.6183 58.0992 78.9183 58.0956 79.2699ZM66.2654 87.0682C65.9778 87.0682 65.7079 87.0451 65.4558 86.9989C65.2072 86.9563 65.0012 86.9013 64.8379 86.8338L65.3493 85.1399C65.6156 85.2216 65.8553 85.266 66.0684 85.2731C66.285 85.2802 66.4714 85.2305 66.6277 85.1239C66.7875 85.0174 66.9171 84.8363 67.0165 84.5806L67.1497 84.2344L64.2147 75.8182H66.601L68.2949 81.8267H68.3801L70.09 75.8182H72.4924L69.3123 84.8842C69.1596 85.3246 68.9519 85.7081 68.6891 86.0348C68.4299 86.3651 68.1014 86.619 67.7037 86.7965C67.3059 86.9776 66.8265 87.0682 66.2654 87.0682ZM21.5038 97.2699V102H19.2346V91.0909H21.4399V95.2617H21.5358C21.7204 94.7788 22.0187 94.4006 22.4307 94.1271C22.8426 93.8501 23.3593 93.7116 23.9807 93.7116C24.5489 93.7116 25.0443 93.8359 25.4669 94.0845C25.893 94.3295 26.2233 94.6829 26.4577 95.1445C26.6956 95.6026 26.8128 96.1513 26.8092 96.7905V102H24.54V97.1953C24.5436 96.6911 24.4157 96.2987 24.1565 96.0181C23.9008 95.7376 23.5422 95.5973 23.0805 95.5973C22.7716 95.5973 22.4981 95.663 22.2602 95.7944C22.0258 95.9258 21.8412 96.1175 21.7062 96.3697C21.5748 96.6183 21.5074 96.9183 21.5038 97.2699ZM32.3237 102.16C31.4821 102.16 30.7576 101.989 30.1504 101.648C29.5467 101.304 29.0815 100.817 28.7548 100.189C28.4281 99.5568 28.2647 98.8093 28.2647 97.9464C28.2647 97.1048 28.4281 96.3661 28.7548 95.7305C29.0815 95.0948 29.5414 94.5994 30.1344 94.2443C30.731 93.8892 31.4306 93.7116 32.2331 93.7116C32.7729 93.7116 33.2754 93.7987 33.7406 93.9727C34.2093 94.1431 34.6177 94.4006 34.9657 94.745C35.3173 95.0895 35.5907 95.5227 35.786 96.0447C35.9814 96.5632 36.079 97.1705 36.079 97.8665V98.4897H29.1703V97.0835H33.943C33.943 96.7567 33.872 96.4673 33.7299 96.2152C33.5879 95.9631 33.3908 95.766 33.1387 95.6239C32.8901 95.4783 32.6007 95.4055 32.2704 95.4055C31.926 95.4055 31.6206 95.4854 31.3542 95.6452C31.0914 95.8015 30.8855 96.0128 30.7363 96.2791C30.5872 96.5419 30.5108 96.8349 30.5073 97.158V98.495C30.5073 98.8999 30.5819 99.2496 30.731 99.5444C30.8837 99.8391 31.0985 100.066 31.3755 100.226C31.6525 100.386 31.981 100.466 32.361 100.466C32.6131 100.466 32.8439 100.43 33.0534 100.359C33.263 100.288 33.4423 100.182 33.5914 100.04C33.7406 99.8977 33.8542 99.7237 33.9324 99.5178L36.0311 99.6562C35.9245 100.161 35.7061 100.601 35.3759 100.977C35.0492 101.35 34.6266 101.641 34.1081 101.851C33.5932 102.057 32.9984 102.16 32.3237 102.16ZM39.829 91.0909V102H37.5598V91.0909H39.829ZM41.6468 105.068V93.8182H43.884V95.1925H43.9852C44.0846 94.9723 44.2284 94.7486 44.4166 94.5213C44.6084 94.2905 44.857 94.0987 45.1624 93.946C45.4713 93.7898 45.8548 93.7116 46.3129 93.7116C46.9095 93.7116 47.46 93.8679 47.9642 94.1804C48.4685 94.4893 48.8715 94.9563 49.1734 95.5813C49.4752 96.2028 49.6262 96.9822 49.6262 97.9197C49.6262 98.8324 49.4788 99.603 49.184 100.232C48.8928 100.857 48.4951 101.331 47.9909 101.654C47.4901 101.973 46.9291 102.133 46.3076 102.133C45.8673 102.133 45.4926 102.06 45.1837 101.915C44.8783 101.769 44.6279 101.586 44.4326 101.366C44.2373 101.142 44.0882 100.917 43.9852 100.69H43.9159V105.068H41.6468ZM43.868 97.9091C43.868 98.3956 43.9355 98.82 44.0704 99.1822C44.2053 99.5444 44.4007 99.8267 44.6563 100.029C44.912 100.228 45.2227 100.327 45.5885 100.327C45.9578 100.327 46.2703 100.226 46.526 100.024C46.7817 99.8178 46.9752 99.5337 47.1066 99.1715C47.2416 98.8058 47.309 98.3849 47.309 97.9091C47.309 97.4368 47.2433 97.0213 47.1119 96.6626C46.9806 96.304 46.787 96.0234 46.5313 95.821C46.2757 95.6186 45.9614 95.5174 45.5885 95.5174C45.2192 95.5174 44.9067 95.6151 44.651 95.8104C44.3989 96.0057 44.2053 96.2827 44.0704 96.6413C43.9355 97 43.868 97.4226 43.868 97.9091ZM53.0885 98.7294V98.5483C53.0921 97.9268 53.1471 97.4315 53.2536 97.0621C53.3637 96.6928 53.5235 96.3945 53.733 96.1673C53.9426 95.94 54.1947 95.734 54.4894 95.5494C54.7096 95.4073 54.9067 95.2599 55.0807 95.1072C55.2547 94.9545 55.3932 94.7859 55.4962 94.6012C55.5992 94.413 55.6507 94.2035 55.6507 93.9727C55.6507 93.7276 55.5921 93.5128 55.4749 93.3281C55.3577 93.1435 55.1997 93.0014 55.0008 92.902C54.8055 92.8026 54.5889 92.7528 54.3509 92.7528C54.1201 92.7528 53.9017 92.8043 53.6958 92.9073C53.4898 93.0067 53.3211 93.1559 53.1897 93.3548C53.0583 93.5501 52.9873 93.7933 52.9767 94.0845H50.8034C50.8211 93.3743 50.9916 92.7884 51.3147 92.3267C51.6379 91.8615 52.0658 91.5153 52.5985 91.288C53.1311 91.0572 53.7188 90.9418 54.3616 90.9418C55.0683 90.9418 55.6933 91.0589 56.2366 91.2933C56.7799 91.5241 57.2061 91.8597 57.515 92.3001C57.824 92.7404 57.9784 93.2713 57.9784 93.8928C57.9784 94.3082 57.9092 94.6776 57.7707 95.0007C57.6357 95.3203 57.4458 95.6044 57.2007 95.853C56.9557 96.098 56.6663 96.32 56.3325 96.5188C56.0519 96.6857 55.8211 96.8597 55.64 97.0408C55.4624 97.2219 55.3293 97.4315 55.2405 97.6694C55.1553 97.9073 55.1109 98.2003 55.1073 98.5483V98.7294H53.0885ZM54.1432 102.138C53.7881 102.138 53.4845 102.014 53.2323 101.766C52.9838 101.513 52.8612 101.212 52.8648 100.86C52.8612 100.512 52.9838 100.214 53.2323 99.9652C53.4845 99.7166 53.7881 99.5923 54.1432 99.5923C54.4806 99.5923 54.7771 99.7166 55.0328 99.9652C55.2884 100.214 55.4181 100.512 55.4216 100.86C55.4181 101.094 55.3559 101.309 55.2352 101.505C55.118 101.696 54.9635 101.851 54.7718 101.968C54.58 102.082 54.3705 102.138 54.1432 102.138Z"
                  fill="#5C5A5A"
                />
                <circle cx="39" cy="32" r="32" fill="#3767F0" />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M35.5 16C41.299 16 46 20.701 46 26.5C46 32.299 41.299 37 35.5 37C34.2397 37 33.0343 36.7786 31.9187 36.3738C31.4269 36.1954 30.8801 36.1556 30.3467 36.2866C28.9141 36.6384 27.4515 36.8617 25.9766 36.9529C26.5312 35.4915 26.7229 33.9117 26.5279 32.3512C26.4845 32.004 26.371 31.6996 26.2361 31.4477C25.4477 29.975 25 28.292 25 26.5C25 20.701 29.701 16 35.5 16ZM49 26.5C49 19.0442 42.9558 13 35.5 13C28.0442 13 22 19.0442 22 26.5C22 28.7751 22.564 30.9227 23.5609 32.8066C23.7165 34.1954 23.4282 35.6023 22.731 36.8223L22.6695 36.93C21.8878 38.2979 22.8755 40 24.4511 40C26.6528 40 28.842 39.7377 30.9729 39.2218C32.39 39.7261 33.9146 40 35.5 40C42.9558 40 49 33.9558 49 26.5ZM52.5328 25.3872C51.8996 25.9213 51.8193 26.8677 52.3535 27.5009C54.0056 29.4595 55 31.9867 55 34.75C55 36.6739 54.5183 38.4808 53.6702 40.0612C53.5342 40.3145 53.4214 40.6186 53.3777 40.9637C53.1633 42.6597 53.3827 44.3778 54.0088 45.9584C52.3793 45.8667 50.7634 45.6239 49.1818 45.2341C48.6479 45.1025 48.0996 45.1421 47.6062 45.3222C46.4054 45.7603 45.1074 46 43.75 46C40.9867 46 38.4595 45.0056 36.5009 43.3535C35.8677 42.8193 34.9213 42.8996 34.3872 43.5328C33.853 44.166 33.9333 45.1124 34.5665 45.6465C37.046 47.7381 40.2526 49 43.75 49C45.4334 49 47.0518 48.7074 48.5549 48.1692C50.8203 48.7199 53.1482 49 55.4895 49C57.0915 49 58.0958 47.2694 57.301 45.8784L57.301 45.8784L57.2356 45.764C56.482 44.4452 56.1721 42.9237 56.3441 41.4227C57.4016 39.4305 58 37.1579 58 34.75C58 31.2526 56.7381 28.046 54.6465 25.5665C54.1124 24.9333 53.166 24.853 52.5328 25.3872ZM29.5 28C30.3284 28 31 27.3284 31 26.5C31 25.6716 30.3284 25 29.5 25C28.6716 25 28 25.6716 28 26.5C28 27.3284 28.6716 28 29.5 28ZM37 26.5C37 27.3284 36.3284 28 35.5 28C34.6716 28 34 27.3284 34 26.5C34 25.6716 34.6716 25 35.5 25C36.3284 25 37 25.6716 37 26.5ZM41.5 28C42.3284 28 43 27.3284 43 26.5C43 25.6716 42.3284 25 41.5 25C40.6716 25 40 25.6716 40 26.5C40 27.3284 40.6716 28 41.5 28Z"
                  fill="white"
                />
              </svg>
            </a>
          </div>

          <div className="toast-container position-fixed bottom-0 end-0 p-3">
            <div
              id="liveToast"
              className={chatOpen ? `toast fade show` : `toast fade hide`}
              role="alert"
              aria-live="assertive"
              aria-atomic="true"
            >
              <div className="toast-header">
                <strong className="me-auto">Comments {(props?.isComparison != true) ? "" : `(${props?.comparisonData?.vendorName})`}</strong>
                <MinimizeIcon
                  type="button"
                  className="btn-close_block"
                  data-bs-dismiss="toast"
                  aria-label="Minimize"
                  onClick={openChat}
                  style={{
                    position: "relative",
                    top: "-5px",
                  }}
                />
              </div>

              <div
                className="toast-body chat-sec-body"
                style={{ paddingBottom: "0px" }}
              >
                <Backdrop
                  sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                  }}
                  open={isLoading}
                  style={{
                    position: "absolute",
                    top: 100,
                    left: 150,
                    width: "10%",
                    height: "10%",
                  }}
                >
                  <CircularProgress color="inherit" />
                </Backdrop>
                <div
                  className="chat-sec"
                  onScroll={handleScroll}
                  ref={paragraphRef}
                  style={{ overflowY: "scroll" }}
                >
                  {chatData.map((ele, i) => (
                    <React.Fragment key={i}>
                      {shouldDisplayNewDate(i) && (
                        <span
                          style={{
                            textAlign: "center",
                            display: "block",
                            color: "#9E9E9E",
                            marginBottom: "19px",
                          }}
                        >
                          {formatDate(ele.createdAt)}
                        </span>
                      )}
                      {/* {ele?.commentBy === UserObj?._id && (
                        <ChatActiveUser data={{ ...ele, previous: activeUser(UserObj?._id, chatData, ele, i) }}
                          viewUrlData={viewUrlData} isLastMessage={i === ele.i - 1} />
                      )} */}
                      {(UserObj?.role?.name === "VENDOR" &&
                        ele?.isVendor === true) ||
                        (UserObj?.role?.name !== "VENDOR" &&
                          ele?.isVendor === false) ? (
                        <ChatActiveUser
                          data={{
                            ...ele,
                            previous:
                              ele?.commentBy === UserObj?._id
                                ? activeUser(UserObj?._id, chatData, ele, i)
                                : otherUser(UserObj?._id, chatData, ele, i),
                          }}
                          viewUrlData={viewUrlData}
                          isLastMessage={i === ele.i - 1}
                        />
                      ) : (
                        <ChatOtherUser
                          data={{
                            ...ele,
                            previous: otherUser(UserObj?._id, chatData, ele, i),
                          }}
                          viewUrlData={viewUrlData}
                        />
                      )}

                      {/* {ele?.commentBy !== UserObj?._id && (
                        <ChatOtherUser data={{ ...ele, previous: otherUser(UserObj?._id, chatData, ele, i) }} viewUrlData={viewUrlData} />
                      )} */}
                    </React.Fragment>
                  ))}
                  <div ref={paragraphRef}></div>
                </div>

                {/* <div className="chat">
                  👋🏻In case of any clarification required from Avaada team. Feel
                  free to share your comment here &amp; team will revert you
                  shortly.
                </div>
                <div className="chat">
                  Hi, my issue is for onboarding.
                </div> */}

                <div className="type_reply justify-content-between">
                  <input
                    type="text"
                    placeholder=" Type a reply"
                    className="w-100 p-2 border-0 block_wizard_chat_box"
                    onChange={onTextChange}
                    value={chatText}
                    onKeyPress={onKeyPressHandler}
                  />

                  <input
                    ref={fileRef}
                    accept="application/msword, application/pdf, image/*"
                    onChange={uploadAttachement}
                    onClick={(event) => {
                      event.target.value = null;
                    }}
                    style={{ display: "none" }}
                    type="file"
                  />

                  <span>
                    <div>
                      <AttachFileIcon
                        onClick={handleClick}
                        className="lets_attachfile_icon_ls_onboardding"
                      />
                    </div>
                  </span>

                  <span onClick={submitForm}>
                    <div>
                      <SendIcon className="lets_attachfile_icon_ls_onboardding" />
                    </div>
                  </span>
                </div>
              </div>
              {UserObj?.role?.name !== "VENDOR" && (
                <div className="supportchat_private_switch_react">
                  Private
                  <Switch
                    className="emp-ls-active-txt"
                    checked={!isPrivate}
                    onChange={() => setIsPrivate((prevState) => !prevState)}
                  />
                  Public{" "}
                </div>
              )}
            </div>
          </div>
        </div>

        <AlertComponent
          alertComponent={alertComponent}
          handleClose={handleClose}
        />
        {/* <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop> */}
      </div>
    </div>
  );
}

export default SupportChat;
